import { apiDelete, apiGet, apiPost, apiPut } from '../../MainModule/common/apiTools';
import { IPassportGroupCreateRequest } from '../interfaces/IPassportGroupCreateRequest';
import { getServiceBaseURL } from '../../MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from '../../MainModule/enums/APIServiceEnum';
import { IPassportGroupPage } from '../interfaces/IPassportGroupPage';
import { IPassportGroupPassportPage } from '../interfaces/IPassportGroupPassportPage';
import { IPassportGroup } from '../interfaces/IPassportGroup';
import { IPassportGroupApplyRequest } from '../interfaces/IPassportGroupApplyRequest';
import { IPassportGroupApplyByKnoRequest } from '../interfaces/IPassportGroupApplyByKnoRequest';
import { PassportGroupPassportTypeEnum } from '../../../PassportGroupPackage/PassportGroupFormModule/enums/PassportGroupPassportTypeEnum';
import { IKnmAttachment } from '../../KnmModule/interfaces/IKnmAttachment';
import { ExportFormatsEnum } from '../../ImportExportModule/enums/ExportFormatsEnum';
import { IExport } from '../../ImportExportModule/interfaces/IExport';
import { PassportGroupTypeEnum } from '../enums/PassportGroupTypeEnum';

export async function fetchPassportGroup(id: number | string): Promise<IPassportGroup> {
  return apiGet(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE, false)}/passport-group/${id}`);
}

export async function createPassportGroup(data: IPassportGroupCreateRequest): Promise<void> {
  return apiPost({ url: `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE, false)}/passport-group`, body: data });
}

export async function deletePassportGroup(id: number): Promise<void> {
  return apiDelete(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE, false)}/passport-group/${id}`);
}

export async function fetchPassportGroupPage(
  page: number,
  size: number,
  type: PassportGroupTypeEnum,
  reasonId: number | undefined,
): Promise<IPassportGroupPage> {
  const params = new URLSearchParams();

  params.append('page', page.toString());
  params.append('size', size.toString());
  params.append('type', type);
  typeof reasonId === 'number' && params.append('reason', reasonId.toString());

  return apiGet(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE, false)}/passport-group?${params}`);
}

export async function fetchPassportGroupPassportPage(
  groupId: number | string,
  page: number,
  size: number,
): Promise<IPassportGroupPassportPage> {
  const params = new URLSearchParams();

  params.append('page', page.toString());
  params.append('size', size.toString());

  return apiGet(
    `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE, false)}/passport-group/${groupId}/passports?${params}`,
  );
}

export async function applyPassportGroup(groupId: number, data: IPassportGroupApplyRequest): Promise<void> {
  return apiPost({
    url: `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE, false)}/passport-group/${groupId}/apply`,
    body: data,
  });
}

export async function applyPassportGroupByKno(groupId: number, data: IPassportGroupApplyByKnoRequest): Promise<void> {
  return apiPost({
    url: `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE, false)}/passport-group/${groupId}/apply-by-kno`,
    body: data,
  });
}

export async function applyPassportByKno(
  passportId: number,
  passportType: PassportGroupPassportTypeEnum,
  decision: IKnmAttachment,
): Promise<void> {
  const params = new URLSearchParams();

  params.append('type', passportType);

  return apiPost({
    url: `${getServiceBaseURL(
      APIServiceEnum.KNM_SERVICE,
      false,
    )}/passport-group/passport/${passportId}/apply-by-kno?${params}`,
    body: decision,
  });
}

export async function fetchIsExistsGroupsForCancellation(): Promise<boolean> {
  return apiGet(
    `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE, false)}/passport-group/exists-groups-for-cancellation`,
  );
}

export async function exportPassportGroup(groupId: number, format: ExportFormatsEnum): Promise<IExport> {
  const params = new URLSearchParams();

  params.append('format', format);

  return apiGet(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE, false)}/passport-group/${groupId}/export?${params}`);
}

export async function excludePassports(groupId: number, passportIds: number[]): Promise<boolean> {
  return apiPut(
    `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE, false)}/passport-group/${groupId}/passports/exclude`,
    passportIds,
  );
}
